import { formatNumberToLocale } from './formatNumberToLocale';

export const formatNumberToLocaleOrMock = (
  value: number | undefined,
  loadingText: string,
  loading: boolean,
) =>
  value === undefined || loading ? loadingText : formatNumberToLocale(value);
